import dark from '@r1-frontend/ui-kit/themes/colors/dark';
import { TTheme } from '@r1-frontend/ui-kit/themes/types';

import commonTheme from './theme.common';

const darkTheme: TTheme = {
    ...commonTheme,
    colors: dark,
};

export default darkTheme;
